<div class="can-not-edit-info">
  <div class="can-not-edit-info__icon">
    <mat-icon color="primary">info_outline</mat-icon>
  </div>
  <div class="can-not-edit-info__content" tabindex="0">
    <ng-content></ng-content>
  </div>
</div>
